import CityPageTemplate from "../city-template/CityPageTemplate";
import { auroraConfig } from "./data";

export default function AuroraPage() {
  return <CityPageTemplate config={auroraConfig} />;
}